import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/registration/user-icon.svg'
import _imports_1 from '../../assets/registration/email-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-bc87cd6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable-user-detail" }
const _hoisted_2 = { class: "account-text-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "first-name" }, "First name", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-danger",
  "data-test": "first-name-required"
}
const _hoisted_5 = {
  key: 1,
  class: "text-danger",
  "data-test": "first-name-max"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "User icon"
  })
], -1))
const _hoisted_8 = { class: "account-text-input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "last-name" }, "Last name", -1))
const _hoisted_10 = {
  key: 0,
  class: "text-danger",
  "data-test": "last-name-required"
}
const _hoisted_11 = {
  key: 1,
  class: "text-danger",
  "data-test": "last-name-max"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "User icon"
  })
], -1))
const _hoisted_14 = { class: "account-text-input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_16 = {
  key: 0,
  class: "text-danger",
  "data-test": "email-required"
}
const _hoisted_17 = {
  key: 1,
  class: "text-danger",
  "data-test": "email-invalid"
}
const _hoisted_18 = {
  key: 2,
  class: "text-danger",
  "data-test": "email-error"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Email icon",
    src: _imports_1
  })
], -1))
const _hoisted_21 = {
  key: 1,
  class: "btn-container"
}

import { computed, ref } from "vue";
import axios, { AxiosError } from "axios";
import { useVuelidate } from "@vuelidate/core";
import { email, maxLength, required } from "@vuelidate/validators";
import SubmitButton from "../submit-button.vue";
import { MyAccountDetailsApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'editable-user-details',
  props: {
    editableDetails: {}
  },
  emits: ["toggle-success-message"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const updatedAccountDetails = ref<MyAccountDetailsApiModel>({
  firstName: props.editableDetails.firstName,
  lastName: props.editableDetails.lastName,
  email: props.editableDetails.email,
});

const rules = {
  updatedAccountDetails: {
    firstName: {
      required,
      maxLength: maxLength(40),
    },
    lastName: {
      required,
      maxLength: maxLength(40),
    },
    email: {
      email,
      required,
    },
  },
};

const v$ = useVuelidate(rules, { updatedAccountDetails }, { $autoDirty: true });

const isEditing = ref(false);
const serverError = ref<string | null>(null);
const attemptedToSubmit = ref(false);
const submitStatus = ref("");

const isSubmitted = computed(() => submitStatus.value === "OK");

function removeErrorMessage(): void {
  submitStatus.value = "";
}

async function successfulDetailsUpdate(): Promise<void> {
  isEditing.value = false;
  emit("toggle-success-message", {
    isDetailsUpdated: true,
    detailChanged: "details",
    updatedDetails: updatedAccountDetails.value,
  });
  submitStatus.value = "";
}

async function submitDetails(): Promise<void> {
  await axios
    .post("/api/myaccount/update", updatedAccountDetails.value)
    .then((resp) => {
      if (resp.status === 200) {
        successfulDetailsUpdate();
      }
    })
    .catch((e: AxiosError) => {
      submitStatus.value = "Error";
      const statusCode = e.response?.status;
      if (statusCode === 404) {
        serverError.value = e.response?.data;
      }
    });
  attemptedToSubmit.value = false;
}

async function submitForm(): Promise<void> {
  const isFormValid = await v$.value.$validate();
  attemptedToSubmit.value = true;
  if (!isFormValid) {
    submitStatus.value = "Error";
    attemptedToSubmit.value = false;
  } else {
    submitStatus.value = "OK";
    submitDetails();
  }
}

function resetDetails(): void {
  v$.value.$reset();
  updatedAccountDetails.value.firstName = props.editableDetails.firstName;
  updatedAccountDetails.value.lastName = props.editableDetails.lastName;
  updatedAccountDetails.value.email = props.editableDetails.email;
}

function startEditing(): void {
  isEditing.value = true;
}

function cancelEditing(): void {
  removeErrorMessage();
  isEditing.value = false;
  resetDetails();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      method: "post",
      "data-test": "my-account-details-form",
      onSubmit: _withModifiers(submitForm, ["prevent"]),
      class: "account-details-form"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_unref(v$).updatedAccountDetails.firstName.required.$invalid && submitStatus.value === 'Error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Required field "))
          : _createCommentVNode("", true),
        (_unref(v$).updatedAccountDetails.firstName.maxLength.$invalid && submitStatus.value === 'Error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " First name must be less than 40 characters long. "))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updatedAccountDetails.value.firstName) = $event)),
          type: "text",
          id: "first-name",
          disabled: !isEditing.value,
          class: "text-input",
          onFocus: removeErrorMessage,
          "data-test": "first-name-input"
        }, null, 40, _hoisted_6), [
          [
            _vModelText,
            updatedAccountDetails.value.firstName,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        (_unref(v$).updatedAccountDetails.lastName.required.$invalid && submitStatus.value === 'Error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Required field "))
          : _createCommentVNode("", true),
        (_unref(v$).updatedAccountDetails.lastName.maxLength.$invalid && submitStatus.value === 'Error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Last name must be less than 40 characters long. "))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updatedAccountDetails.value.lastName) = $event)),
          type: "text",
          id: "last-name",
          disabled: !isEditing.value,
          class: "text-input",
          onFocus: removeErrorMessage,
          "data-test": "last-name-input"
        }, null, 40, _hoisted_12), [
          [
            _vModelText,
            updatedAccountDetails.value.lastName,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        (_unref(v$).updatedAccountDetails.email.required.$invalid && submitStatus.value === 'Error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Required field "))
          : _createCommentVNode("", true),
        (_unref(v$).updatedAccountDetails.email.email.$invalid && submitStatus.value === 'Error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Invalid email address "))
          : _createCommentVNode("", true),
        (serverError.value && submitStatus.value === 'Error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(serverError.value), 1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updatedAccountDetails.value.email) = $event)),
          id: "email",
          disabled: !isEditing.value,
          class: "text-input",
          onFocus: removeErrorMessage,
          "data-test": "email-input"
        }, null, 40, _hoisted_19), [
          [
            _vModelText,
            updatedAccountDetails.value.email,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_20
      ]),
      (!isEditing.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-default-edit",
            onClick: _withModifiers(startEditing, ["prevent"]),
            "data-test": "edit-button",
            type: "button"
          }, " Edit Details "))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createVNode(SubmitButton, {
              "data-test": "submit-details",
              buttonClass: 'btn-primary',
              isSubmitted: isSubmitted.value,
              useRecaptcha: false,
              disabled: attemptedToSubmit.value,
              style: {"min-width":"120px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save Changes")
              ]),
              _: 1
            }, 8, ["isSubmitted", "disabled"]),
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: cancelEditing,
              "data-test": "cancel-editing",
              type: "button"
            }, " Cancel ")
          ]))
    ], 32)
  ]))
}
}

})